import ApiClient from '@/api/ApiClient';
import {
  isTypePaymentMethodListResponse,
  isTypePaymentMethodCardListResponse,
  isTypeCard3dsChallengeResponse,
} from '@/model/TypeGuard/Payment';
import {
  PaymentMethodCardResponse,
  PaymentMethodCardListResponse,
  PaymentMethodResponse,
  PaymentMethodListResponse,
  CreatePaymentMethodCardResponse,
} from '@API/src/component/home/payment/types';
import {
  FetchPaymentMethodRequest,
  PutPaymentMethodRequest,
  PostPaymentMethodCardRequest,
  DeletePaymentMethodCardRequest,
  FetchPaymentMethodCardRequest,
} from '@/model/Payment';

export default class ApiAttachment {

  public static async fetchPaymentMethod(request: FetchPaymentMethodRequest): Promise<PaymentMethodListResponse> {
    try {
      const response = await ApiClient.get(`/payment-method`, request);
      if (isTypePaymentMethodListResponse(response)) {
        return response;
      }
      throw response;
    } catch (error) {
      throw error;
    }
  }

  public static async putPaymentMethod(request: PutPaymentMethodRequest): Promise<PaymentMethodListResponse> {
    try {
      const response = await ApiClient.put(`/payment-method`, request);
      if (isTypePaymentMethodListResponse(response)) {
        return response;
      }
      throw response;
    } catch (error) {
      throw error;
    }
  }

  public static async postPaymentMethodCard(request: PostPaymentMethodCardRequest): Promise<CreatePaymentMethodCardResponse> {
    try {
      const response = await ApiClient.post(`/payment-method/card`, request);
      // 3Dセキュアのチャレンジ認証が必要な場合、バックエンドは
      // { requires3ds: true, redirectUrl, accessPass } を返す。
      // これはカード一覧(配列)の形ではないため、先に別枠で判定する。
      // (isTypePaymentMethodCardListResponse は配列判定のためfalseになり、
      //  この分岐が無いとエラーとしてthrowされてしまう)
      if (isTypeCard3dsChallengeResponse(response)) {
        return response;
      }
      if (isTypePaymentMethodCardListResponse(response)) {
        return response;
      }
      throw response;
    } catch (error) {
      throw error;
    }
  }

  public static async deletePaymentMethodCard(request: DeletePaymentMethodCardRequest): Promise<PaymentMethodCardListResponse> {
    try {
      const response = await ApiClient.delete(`/payment-method/card`, request);
      if (isTypePaymentMethodCardListResponse(response)) {
        return response;
      }
      throw response;
    } catch (error) {
      throw error;
    }
  }

  public static async fetchPaymentMethodCard(request: FetchPaymentMethodCardRequest): Promise<PaymentMethodCardListResponse> {
    try {
      const response = await ApiClient.get(`/payment-method/card`, request);
      if (isTypePaymentMethodCardListResponse(response)) {
        return response;
      }
      throw response;
    } catch (error) {
      throw error;
    }
  }

}
